import { useReduxState } from 'hooks';
import { Page, PageContent, PageHeader, PageNav } from 'components/page';

import type { NavLink } from 'types';

interface Props {
  accountDeleteRequests?: number;
  activeLink: string;
  children: React.ReactNode;
  withSidebar?: boolean;
}

const AdminPage = ({ activeLink, children, withSidebar }: Props) => {
  const { messages, user } = useReduxState();

  const links: NavLink[] = [
    {
      href: '/admin/admins',
      icon: 'user-shield',
      title: messages.usersAdmins
    },
    {
      href: '/admin/users-merge',
      icon: 'user-friends',
      title: messages.usersMerge
    },
    {
      href: '/admin/events',
      icon: 'list',
      title: messages.adminLogs
    },
    {
      href: '/admin/overview',
      icon: 'info-circle',
      title: messages.clientPageTitle
    },
    {
      alignRight: true,
      href: user?.roles.includes('vuoadmin')
        ? '/admin/settings'
        : '/admin/settings/home-page',
      icon: 'cog',
      title: messages.adminSettings
    }
  ];

  return (
    <Page
      activePathname={
        user?.roles.includes('superadmin')
          ? '/admin/admins'
          : '/admin/settings/user-attributes'
      }
    >
      <PageHeader
        icon="user-shield"
        title={
          user?.roles.includes('superadmin')
            ? 'Superadmin'
            : messages.adminSettings
        }
      />

      {user?.roles.includes('superadmin') ? (
        <PageNav activeLink={activeLink} links={links} />
      ) : null}

      <PageContent withSidebar={withSidebar}>{children}</PageContent>
    </Page>
  );
};

export default AdminPage;
